// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1IC3l","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3wjf4","obliqueLine":"membershipbadge_obliqueLine__1-XiQ"};